module.exports = __webpack_public_path__ + "static/media/no-image.2bd4b1df.png";